module.exports = "<p>איזה כיף, נשמח לשמוע! אם יש לכם הצעות לשיפור ורעיונות שתרצו לחלוק אתנו, תוכלו להשאיר לנו הודעה בעמוד &quot;צור קשר&quot; שבתחתית האתר. אנחנו נחזור אליכם ונודה לכם באופן אישי.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/help/he/16.md
// module id = 809
// module chunks = 0